import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const nav = css`
  /* 
    Override styles for the top level list within the tree
  */
  & > ul {
    display: grid;
    gap: ${size[16]};
    margin: 0;

    &::before {
      content: none;
    }
  }
`
